import React, { useMemo } from "react";

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from "@mui/lab";

import {
  EOrderStatusFinally,
  EOrderStatusDescription,
} from "enums/options/orders";
import { OrderProps } from "store/modules/Orders/types.store";
import { format } from "date-fns";
import { ChamaDate } from "ctech-react-components";

interface CardAccordionProps {
  dataOrder: OrderProps;
  currentTab?: string;
}

const TimeLine: React.FC<CardAccordionProps> = ({ dataOrder, currentTab }) => {
  const timeLineStatus: any = useMemo(() => {
    // TODO: Remover por enquanto da lista o ETA atualizado
    const timeLine = dataOrder?.timeline
      ?.filter((value) => value?.description !== EOrderStatusFinally.ETAUPDATED)
      ?.map((x) => ({
        date: x?.occurredAt?.substr(0, 22),
        description: EOrderStatusDescription[x?.description as any] || "",
      }));

    if (currentTab === "1") {
      timeLine?.push(
        {
          date: "",
          description: "Revenda aceitou",
        },
        {
          date: "",
          description: "Entregue",
        },
      );
    }

    if (currentTab === "2") {
      timeLine?.push({
        date: "",
        description: "Entregue",
      });
    }

    return timeLine;
  }, [dataOrder, currentTab]);

  return (
    <Timeline position="right">
      {timeLineStatus?.map((values: any, index: number) => {
        return (
          <TimelineItem key={String(index).concat(values?.description)}>
            <TimelineOppositeContent color="text.secondary">
              {values?.date
                ? format(
                    new Date(
                      ChamaDate.fromPersistence(values?.date || "").toView(),
                    ),
                    "HH:mm",
                  )
                : ""}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot color={values?.date ? "success" : "grey"} />

              {timeLineStatus?.length !== index + 1 && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent minWidth={130}>
              {values?.description}
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
};

export default TimeLine;
